/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-airbnb': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<metadata id="metadata62"/><path pid="0" _fill="currentColor" d="M8 18.932c-.847-1.063-1.345-1.995-1.51-2.793-.758-2.954 3.78-2.954 3.023 0-.183.815-.681 1.746-1.51 2.793zm4.638 2.459c-1.412.614-2.809-.366-4.005-1.695 3.488-4.367 1.548-6.714-.633-6.714-1.844 0-2.859 1.561-2.46 3.374.233.98.847 2.094 1.827 3.34-1.092 1.21-2.033 1.77-2.858 1.844-1.68.25-2.992-1.378-2.394-3.058.507-1.315 3.75-7.762 3.89-8.11.529-1.01.858-1.927 1.994-1.927 1.085 0 1.457.87 2.026 2.01 1.209 2.37 3 5.958 3.856 8.027.442 1.11-.046 2.393-1.243 2.909zm1.578-4.57C9.89 7.61 9.65 7.48 8 7.48c-1.528 0-2.178 1.063-2.842 2.443-3.564 7.128-3.91 8.139-3.94 8.226-.846 2.328.898 4.371 3.01 4.371.728 0 2.034-.203 3.772-2.095 1.97 2.142 3.4 2.095 3.773 2.095 2.111.002 3.856-2.043 3.008-4.37 0-.131-.564-1.307-.564-1.33z" id="path124" stroke-width=".034"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-airbnb.js